import React from 'react';
import { Helmet } from 'react-helmet';
import { useSelector } from 'react-redux';

import { MeSelectors } from '../../redux/selectors';
import { UserRole } from '../../../../shared/enums';

const ChatbaseInit = () => {
  const { CHATBASE_CUSTOMER_ID } = process.env;
  // const { CHATBASE_WRITER_ID } = process.env;

  const me = useSelector(MeSelectors.selectMe);

  const addBotScriptById = (id) => (
    <Helmet>
      <script type="text/javascript">
        {`
            window.embeddedChatbotConfig = {
            chatbotId: "${id}",
            domain: "www.chatbase.co"
            }
        `}
      </script>
      <script
        type="text/javascript"
        src="https://www.chatbase.co/embed.min.js"
          // eslint-disable-next-line react/no-unknown-property
        chatbotId={id}
          // eslint-disable-next-line react/no-unknown-property
        domain="www.chatbase.co"
        defer
      />
    </Helmet>
  );

  const getChatbotId = () => {
    if (me?.role === UserRole.CUSTOMER || window.location.pathname === '/no-project-for-customer') {
      return CHATBASE_CUSTOMER_ID;
    }
    // TODO on show also change roles in modal: /src/client/new-design/views/components/FeatureInfoModal/index.js
    // if (me?.role === UserRole.WRITER) {
    //   return CHATBASE_WRITER_ID;
    // }
    return null;
  };

  const chatbotId = getChatbotId();

  return chatbotId ? addBotScriptById(chatbotId) : null;
};

export default ChatbaseInit;
